export const BulkUploadAnnouncementImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="499"
      height="212"
      viewBox="0 0 499 212"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <g clipPath="url(#clip0_17125_5485)">
        <mask id="path-1-inside-1_17125_5485" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M432.855 59.2443C428.731 59.2443 424.737 59.7978 420.942 60.8344C420.149 58.0575 419.196 55.3229 418.086 52.6444C414.285 43.477 408.714 35.1474 401.692 28.131C394.669 21.1146 386.332 15.5489 377.157 11.7517C367.981 7.95441 358.147 6 348.216 6C338.284 6 328.45 7.95441 319.275 11.7517C310.099 15.5489 301.762 21.1146 294.74 28.131C287.717 35.1474 282.146 43.477 278.346 52.6444C277.381 54.9721 276.535 57.3422 275.809 59.7456C273.608 59.4154 271.356 59.2443 269.063 59.2443C244.175 59.2443 224 79.4017 224 104.267C224 128.212 242.71 147.791 266.32 149.208V149.29H436.382V149.154C459.621 147.357 477.917 127.947 477.917 104.267C477.917 79.4017 457.742 59.2443 432.855 59.2443Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M432.855 59.2443C428.731 59.2443 424.737 59.7978 420.942 60.8344C420.149 58.0575 419.196 55.3229 418.086 52.6444C414.285 43.477 408.714 35.1474 401.692 28.131C394.669 21.1146 386.332 15.5489 377.157 11.7517C367.981 7.95441 358.147 6 348.216 6C338.284 6 328.45 7.95441 319.275 11.7517C310.099 15.5489 301.762 21.1146 294.74 28.131C287.717 35.1474 282.146 43.477 278.346 52.6444C277.381 54.9721 276.535 57.3422 275.809 59.7456C273.608 59.4154 271.356 59.2443 269.063 59.2443C244.175 59.2443 224 79.4017 224 104.267C224 128.212 242.71 147.791 266.32 149.208V149.29H436.382V149.154C459.621 147.357 477.917 127.947 477.917 104.267C477.917 79.4017 457.742 59.2443 432.855 59.2443Z"
          fill="#A9C4FF"
        />
        <path
          d="M420.942 60.8344L420.365 60.9991L420.528 61.5695L421.1 61.4132L420.942 60.8344ZM418.086 52.6444L418.64 52.4146L418.086 52.6444ZM401.692 28.131L402.116 27.7065L401.692 28.131ZM377.157 11.7517L376.927 12.3061L377.157 11.7517ZM319.275 11.7517L319.045 11.1973L319.275 11.7517ZM294.74 28.131L295.164 28.5554L294.74 28.131ZM278.346 52.6444L277.792 52.4146L278.346 52.6444ZM275.809 59.7456L275.72 60.3389L276.234 60.4159L276.384 59.9189L275.809 59.7456ZM266.32 149.208H266.92V148.643L266.356 148.609L266.32 149.208ZM266.32 149.29H265.72V149.89H266.32V149.29ZM436.382 149.29V149.89H436.982V149.29H436.382ZM436.382 149.154L436.335 148.556L435.782 148.599V149.154H436.382ZM421.1 61.4132C424.844 60.3905 428.785 59.8443 432.855 59.8443V58.6443C428.677 58.6443 424.63 59.205 420.784 60.2556L421.1 61.4132ZM417.531 52.8741C418.633 55.5314 419.578 58.2443 420.365 60.9991L421.519 60.6697C420.72 57.8708 419.759 55.1143 418.64 52.4146L417.531 52.8741ZM401.268 28.5554C408.235 35.5161 413.761 43.7796 417.531 52.8741L418.64 52.4146C414.809 43.1744 409.194 34.7786 402.116 27.7065L401.268 28.5554ZM376.927 12.3061C386.03 16.0732 394.301 21.5947 401.268 28.5554L402.116 27.7065C395.038 20.6344 386.634 15.0246 377.386 11.1973L376.927 12.3061ZM348.216 6.6C358.068 6.6 367.825 8.53892 376.927 12.3061L377.386 11.1973C368.138 7.3699 358.226 5.4 348.216 5.4V6.6ZM319.504 12.3061C328.607 8.53892 338.363 6.6 348.216 6.6V5.4C338.206 5.4 328.293 7.36991 319.045 11.1973L319.504 12.3061ZM295.164 28.5554C302.131 21.5947 310.401 16.0732 319.504 12.3061L319.045 11.1973C309.797 15.0246 301.394 20.6345 294.316 27.7065L295.164 28.5554ZM278.9 52.8741C282.671 43.7796 288.197 35.5161 295.164 28.5554L294.316 27.7065C287.237 34.7786 281.622 43.1744 277.792 52.4146L278.9 52.8741ZM276.384 59.9189C277.103 57.5347 277.943 55.1834 278.9 52.8741L277.792 52.4146C276.819 54.7608 275.966 57.1497 275.235 59.5722L276.384 59.9189ZM269.063 59.8443C271.326 59.8443 273.549 60.0132 275.72 60.3389L275.898 59.1522C273.668 58.8177 271.385 58.6443 269.063 58.6443V59.8443ZM224.6 104.267C224.6 79.7336 244.506 59.8443 269.063 59.8443V58.6443C243.844 58.6443 223.4 79.0698 223.4 104.267H224.6ZM266.356 148.609C243.06 147.211 224.6 127.892 224.6 104.267H223.4C223.4 128.532 242.359 148.371 266.284 149.807L266.356 148.609ZM266.92 149.29V149.208H265.72V149.29H266.92ZM436.382 148.69H266.32V149.89H436.382V148.69ZM435.782 149.154V149.29H436.982V149.154H435.782ZM477.317 104.267C477.317 127.63 459.265 146.782 436.335 148.556L436.428 149.752C459.976 147.931 478.517 128.263 478.517 104.267H477.317ZM432.855 59.8443C457.411 59.8443 477.317 79.7336 477.317 104.267H478.517C478.517 79.0698 458.073 58.6443 432.855 58.6443V59.8443Z"
          fill="#1D2B47"
          mask="url(#path-1-inside-1_17125_5485)"
        />
        <path
          d="M345.295 113.271C340.877 113.271 337.295 109.69 337.295 105.271V96.5897C337.295 93.4061 334.714 90.8253 331.53 90.8253C326.71 90.8253 324.019 85.2604 327.012 81.4817L345.866 57.6781C348.401 54.4787 353.256 54.4787 355.79 57.6781L374.644 81.4817C377.637 85.2604 374.946 90.8253 370.126 90.8253C366.942 90.8253 364.361 93.4061 364.361 96.5897V105.271C364.361 109.69 360.78 113.271 356.361 113.271H345.295Z"
          fill="white"
          stroke="#1D2B47"
          strokeWidth="0.6"
        />
        <rect
          width="94.37"
          height="111.202"
          rx="36.68"
          transform="matrix(-0.996167 -0.0874757 -0.0876291 0.996153 269.019 113.28)"
          fill="#ACC7FA"
          stroke="#272D41"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <rect
          width="76.1042"
          height="91.1185"
          rx="5"
          transform="matrix(-0.996167 -0.0874757 -0.0876291 0.996153 259.036 122.553)"
          fill="#A3B1D5"
          stroke="#272D41"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M172.17 203.433L174.446 177.829L183.582 170.798C185.678 169.187 188.7 169.488 190.437 171.479L199.577 181.957L217.036 170.678C218.98 169.419 221.558 169.655 223.24 171.246L253.283 199.761L253.638 200.862L252.775 210.585C252.614 212.382 251 213.707 249.168 213.546L175.185 206.983C173.357 206.815 172.008 205.227 172.17 203.433Z"
          fill="#ACC7FA"
        />
        <ellipse
          cx="3.92873"
          cy="3.8593"
          rx="3.92873"
          ry="3.8593"
          transform="matrix(-0.995878 0.0907088 0.0972993 0.995255 242.142 166.886)"
          fill="#ACC7FA"
        />
        <rect
          width="76.1042"
          height="91.1185"
          rx="5"
          transform="matrix(-0.996167 -0.0874757 -0.0876291 0.996153 259.036 122.553)"
          stroke="#272D41"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M257.065 112.232C263.667 112.811 268.548 118.633 267.967 125.235L260.326 212.102C259.745 218.704 253.922 223.586 247.32 223.006L177.22 216.851C170.618 216.271 165.737 210.449 166.317 203.847L173.959 116.98C174.54 110.378 180.362 105.496 186.964 106.076L257.065 112.232ZM254.055 122.114C256.806 122.356 258.839 124.782 258.597 127.533L251.489 208.339C251.247 211.09 248.821 213.124 246.07 212.882L180.219 207.1C177.468 206.858 175.435 204.432 175.677 201.682L182.785 120.875C183.027 118.124 185.453 116.09 188.204 116.332L254.055 122.114Z"
          fill="#DBE7FF"
        />
        <path
          d="M267.967 125.235L268.266 125.262L267.967 125.235ZM257.065 112.232L257.091 111.933L257.065 112.232ZM260.326 212.102L260.027 212.076L260.326 212.102ZM247.32 223.006L247.294 223.305L247.32 223.006ZM177.22 216.851L177.246 216.552L177.22 216.851ZM166.317 203.847L166.616 203.873L166.317 203.847ZM173.959 116.98L173.66 116.954L173.959 116.98ZM186.964 106.076L186.938 106.375L186.964 106.076ZM258.597 127.533L258.896 127.559L258.597 127.533ZM254.055 122.114L254.028 122.413L254.055 122.114ZM251.489 208.339L251.19 208.313L251.489 208.339ZM246.07 212.882L246.044 213.181L246.07 212.882ZM180.219 207.1L180.245 206.801L180.219 207.1ZM175.677 201.682L175.975 201.708L175.677 201.682ZM182.785 120.875L182.486 120.849L182.785 120.875ZM188.204 116.332L188.23 116.033L188.204 116.332ZM267.668 125.209C268.235 118.772 263.475 113.096 257.038 112.531L257.091 111.933C263.858 112.527 268.861 118.495 268.266 125.262L267.668 125.209ZM260.027 212.076L267.668 125.209L268.266 125.262L260.625 212.128L260.027 212.076ZM247.346 222.707C253.783 223.273 259.461 218.513 260.027 212.076L260.625 212.128C260.029 218.895 254.061 223.899 247.294 223.305L247.346 222.707ZM177.246 216.552L247.346 222.707L247.294 223.305L177.194 217.149L177.246 216.552ZM166.616 203.873C166.05 210.31 170.809 215.987 177.246 216.552L177.194 217.149C170.427 216.555 165.423 210.588 166.019 203.821L166.616 203.873ZM174.258 117.006L166.616 203.873L166.019 203.821L173.66 116.954L174.258 117.006ZM186.938 106.375C180.501 105.81 174.824 110.57 174.258 117.006L173.66 116.954C174.255 110.187 180.224 105.183 186.991 105.777L186.938 106.375ZM257.038 112.531L186.938 106.375L186.991 105.777L257.091 111.933L257.038 112.531ZM258.299 127.506C258.526 124.921 256.614 122.64 254.028 122.413L254.081 121.816C256.997 122.072 259.153 124.643 258.896 127.559L258.299 127.506ZM251.19 208.313L258.299 127.506L258.896 127.559L251.788 208.365L251.19 208.313ZM246.096 212.583C248.682 212.811 250.963 210.898 251.19 208.313L251.788 208.365C251.531 211.281 248.96 213.437 246.044 213.181L246.096 212.583ZM180.245 206.801L246.096 212.583L246.044 213.181L180.193 207.399L180.245 206.801ZM175.975 201.708C175.748 204.294 177.66 206.574 180.245 206.801L180.193 207.399C177.277 207.143 175.121 204.571 175.378 201.655L175.975 201.708ZM183.084 120.902L175.975 201.708L175.378 201.655L182.486 120.849L183.084 120.902ZM188.178 116.631C185.592 116.404 183.311 118.316 183.084 120.902L182.486 120.849C182.743 117.933 185.314 115.777 188.23 116.033L188.178 116.631ZM254.028 122.413L188.178 116.631L188.23 116.033L254.081 121.816L254.028 122.413Z"
          fill="#272D41"
        />
        <rect
          width="94.3703"
          height="111.202"
          rx="36.68"
          transform="matrix(-0.997609 0.0691083 0.0692299 0.997601 256.317 106.862)"
          fill="#ACC7FA"
          stroke="#272D41"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <rect
          width="76.1044"
          height="91.1182"
          rx="5"
          transform="matrix(-0.997609 0.0691083 0.0692299 0.997601 247.906 117.577)"
          fill="#F7F9FE"
          stroke="#272D41"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M174.756 211.025L173 185.381L180.924 177.01C182.743 175.092 185.775 174.917 187.801 176.613L198.468 185.535L213.948 171.669C215.672 170.122 218.255 169.953 220.165 171.262L254.298 194.736L254.821 195.769L255.489 205.507C255.612 207.307 254.224 208.868 252.39 208.994L178.289 214.062C176.457 214.181 174.876 212.823 174.756 211.025Z"
          fill="#ACC7FA"
        />
        <ellipse
          cx="3.92855"
          cy="3.85948"
          rx="3.92855"
          ry="3.85948"
          transform="matrix(-0.969505 0.245071 0.251735 0.967796 238.153 164.005)"
          fill="#ACC7FA"
        />
        <rect
          width="76.1044"
          height="91.1182"
          rx="5"
          transform="matrix(-0.997609 0.0691083 0.0692299 0.997601 247.906 117.577)"
          stroke="#272D41"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M244.345 107.696C250.957 107.238 256.689 112.226 257.148 118.838L263.185 205.831C263.643 212.442 258.656 218.173 252.044 218.631L181.842 223.494C175.23 223.953 169.499 218.964 169.04 212.353L163.003 125.36C162.544 118.748 167.532 113.017 174.143 112.559L244.345 107.696ZM242.918 117.927C245.673 117.736 248.061 119.815 248.252 122.57L253.868 203.493C254.059 206.248 251.981 208.636 249.226 208.827L183.28 213.395C180.525 213.586 178.137 211.507 177.946 208.753L172.33 127.829C172.139 125.074 174.217 122.686 176.972 122.496L242.918 117.927Z"
          fill="white"
        />
        <path
          d="M257.148 118.838L256.848 118.859L257.148 118.838ZM244.345 107.696L244.325 107.397L244.345 107.696ZM263.185 205.831L262.885 205.852L263.185 205.831ZM252.044 218.631L252.023 218.332L252.044 218.631ZM181.842 223.494L181.863 223.794L181.842 223.494ZM169.04 212.353L168.741 212.373L169.04 212.353ZM163.003 125.36L163.302 125.339L163.003 125.36ZM174.143 112.559L174.123 112.26L174.143 112.559ZM248.252 122.57L248.552 122.549L248.252 122.57ZM242.918 117.927L242.939 118.226L242.918 117.927ZM253.868 203.493L253.569 203.514L253.868 203.493ZM249.226 208.827L249.247 209.126L249.226 208.827ZM183.28 213.395L183.259 213.096L183.28 213.395ZM177.946 208.753L178.245 208.732L177.946 208.753ZM172.33 127.829L172.031 127.85L172.33 127.829ZM176.972 122.496L176.992 122.795L176.972 122.496ZM256.848 118.859C256.401 112.412 250.813 107.549 244.366 107.995L244.325 107.397C251.102 106.927 256.977 112.04 257.447 118.817L256.848 118.859ZM262.885 205.852L256.848 118.859L257.447 118.817L263.484 205.81L262.885 205.852ZM252.023 218.332C258.47 217.885 263.333 212.298 262.885 205.852L263.484 205.81C263.954 212.587 258.842 218.461 252.065 218.931L252.023 218.332ZM181.821 223.195L252.023 218.332L252.065 218.931L181.863 223.794L181.821 223.195ZM169.339 212.332C169.787 218.778 175.375 223.642 181.821 223.195L181.863 223.794C175.086 224.263 169.211 219.15 168.741 212.373L169.339 212.332ZM163.302 125.339L169.339 212.332L168.741 212.373L162.704 125.381L163.302 125.339ZM174.164 112.859C167.718 113.305 162.855 118.893 163.302 125.339L162.704 125.381C162.233 118.604 167.346 112.729 174.123 112.26L174.164 112.859ZM244.366 107.995L174.164 112.859L174.123 112.26L244.325 107.397L244.366 107.995ZM247.953 122.59C247.773 120.001 245.528 118.047 242.939 118.226L242.897 117.628C245.817 117.426 248.349 119.629 248.552 122.549L247.953 122.59ZM253.569 203.514L247.953 122.59L248.552 122.549L254.167 203.472L253.569 203.514ZM249.205 208.527C251.795 208.348 253.748 206.103 253.569 203.514L254.167 203.472C254.37 206.393 252.167 208.924 249.247 209.126L249.205 208.527ZM183.259 213.096L249.205 208.527L249.247 209.126L183.301 213.694L183.259 213.096ZM178.245 208.732C178.425 211.321 180.67 213.275 183.259 213.096L183.301 213.694C180.38 213.897 177.849 211.693 177.646 208.773L178.245 208.732ZM172.629 127.808L178.245 208.732L177.646 208.773L172.031 127.85L172.629 127.808ZM176.992 122.795C174.403 122.974 172.449 125.219 172.629 127.808L172.031 127.85C171.828 124.93 174.031 122.399 176.951 122.196L176.992 122.795ZM242.939 118.226L176.992 122.795L176.951 122.196L242.897 117.628L242.939 118.226Z"
          fill="#272D41"
        />
        <rect
          width="80.0272"
          height="111.202"
          rx="36.68"
          transform="matrix(-0.999119 -0.0419617 -0.0420357 0.999116 248.431 113.827)"
          fill="#ACC7FA"
          stroke="#272D41"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <rect
          width="64.5376"
          height="91.118"
          rx="5"
          transform="matrix(-0.999119 -0.0419617 -0.0420357 0.999116 240.269 123.603)"
          fill="#F7F9FE"
          stroke="#272D41"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M169.252 208.866L170.352 183.186L177.869 175.691C179.594 173.974 182.166 174.117 183.702 176.015L191.79 186.001L206.224 173.833C207.831 172.475 210.024 172.577 211.502 174.079L237.892 200.987L238.228 202.068L237.811 211.82C237.733 213.622 236.408 215.029 234.85 214.963L171.922 212.255C170.367 212.182 169.172 210.666 169.252 208.866Z"
          fill="#ACC7FA"
        />
        <ellipse
          cx="3.35202"
          cy="3.84092"
          rx="3.35202"
          ry="3.84092"
          transform="matrix(-0.985994 0.166783 0.115245 0.993337 227.383 168.743)"
          fill="#ACC7FA"
        />
        <rect
          width="64.5376"
          height="91.118"
          rx="5"
          transform="matrix(-0.999119 -0.0419617 -0.0420357 0.999116 240.269 123.603)"
          stroke="#272D41"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M236.442 113.324C243.063 113.602 248.205 119.196 247.927 125.817L244.261 212.942C243.983 219.563 238.389 224.706 231.767 224.428L175.789 222.077C169.168 221.799 164.026 216.205 164.304 209.584L167.97 122.459C168.249 115.837 173.842 110.695 180.464 110.973L236.442 113.324ZM235.273 123.393C238.032 123.509 240.174 125.84 240.058 128.599L236.649 209.645C236.532 212.404 234.202 214.547 231.443 214.431L176.953 212.142C174.194 212.026 172.052 209.696 172.168 206.937L175.578 125.891C175.694 123.132 178.024 120.989 180.783 121.105L235.273 123.393Z"
          fill="#E4D8FF"
        />
        <path
          d="M247.927 125.817L247.627 125.804L247.927 125.817ZM236.442 113.324L236.429 113.624L236.442 113.324ZM244.261 212.942L244.561 212.954L244.261 212.942ZM231.767 224.428L231.78 224.128L231.767 224.428ZM175.789 222.077L175.777 222.376L175.789 222.077ZM164.304 209.584L164.005 209.571L164.304 209.584ZM167.97 122.459L168.27 122.472L167.97 122.459ZM180.464 110.973L180.451 111.273L180.464 110.973ZM240.058 128.599L239.759 128.586L240.058 128.599ZM235.273 123.393L235.286 123.094L235.273 123.393ZM236.649 209.645L236.948 209.658L236.649 209.645ZM231.443 214.431L231.455 214.131L231.455 214.131L231.443 214.431ZM176.953 212.142L176.941 212.442L176.953 212.142ZM172.168 206.937L171.868 206.924L172.168 206.937ZM175.578 125.891L175.877 125.903L175.877 125.903L175.578 125.891ZM180.783 121.105L180.771 121.405L180.783 121.105ZM247.627 125.804C247.899 119.348 242.885 113.895 236.429 113.624L236.454 113.024C243.241 113.309 248.512 119.043 248.226 125.83L247.627 125.804ZM243.961 212.929L247.627 125.804L248.226 125.83L244.561 212.954L243.961 212.929ZM231.78 224.128C238.236 224.399 243.69 219.385 243.961 212.929L244.561 212.954C244.275 219.741 238.542 225.012 231.755 224.727L231.78 224.128ZM175.802 221.777L231.78 224.128L231.755 224.727L175.777 222.376L175.802 221.777ZM164.604 209.596C164.333 216.052 169.346 221.506 175.802 221.777L175.777 222.376C168.99 222.091 163.719 216.358 164.005 209.571L164.604 209.596ZM168.27 122.472L164.604 209.596L164.005 209.571L167.67 122.446L168.27 122.472ZM180.451 111.273C173.995 111.002 168.541 116.016 168.27 122.472L167.67 122.446C167.956 115.659 173.689 110.388 180.476 110.673L180.451 111.273ZM236.429 113.624L180.451 111.273L180.476 110.673L236.454 113.024L236.429 113.624ZM239.759 128.586C239.868 125.993 237.854 123.802 235.26 123.693L235.286 123.094C238.21 123.216 240.481 125.687 240.358 128.611L239.759 128.586ZM236.349 209.632L239.759 128.586L240.358 128.611L236.948 209.658L236.349 209.632ZM231.455 214.131C234.049 214.24 236.24 212.226 236.349 209.632L236.948 209.658C236.825 212.582 234.355 214.853 231.43 214.73L231.455 214.131ZM176.966 211.843L231.455 214.131L231.43 214.73L176.941 212.442L176.966 211.843ZM172.468 206.949C172.358 209.543 174.372 211.734 176.966 211.843L176.941 212.442C174.016 212.319 171.745 209.849 171.868 206.924L172.468 206.949ZM175.877 125.903L172.468 206.949L171.868 206.924L175.278 125.878L175.877 125.903ZM180.771 121.405C178.177 121.296 175.987 123.31 175.877 125.903L175.278 125.878C175.401 122.953 177.872 120.682 180.796 120.805L180.771 121.405ZM235.26 123.693L180.771 121.405L180.796 120.805L235.286 123.094L235.26 123.693Z"
          fill="#272D41"
        />
        <path
          d="M154.444 143.079H258.091V229.415H154.444V143.079Z"
          fill="white"
          stroke="#1D2B47"
          strokeWidth="0.6"
        />
        <path
          d="M229.523 143.079H283.589V229.415H229.523V143.079Z"
          fill="white"
          stroke="#1D2B47"
          strokeWidth="0.6"
        />
        <path
          d="M229.523 143.079L244.118 161.139C244.891 162.098 246.058 162.655 247.29 162.655H290.723C292.287 162.654 293.713 161.76 294.393 160.352C295.073 158.944 294.887 157.272 293.914 156.048L283.589 143.076L229.523 143.079Z"
          fill="white"
          stroke="#1D2B47"
          strokeWidth="0.6"
        />
        <path
          d="M215.099 161.95H148.557C147.247 161.95 146.043 161.231 145.423 160.078C144.804 158.924 144.868 157.524 145.592 156.433L154.447 143.084H229.523L218.064 160.359C217.405 161.353 216.292 161.95 215.099 161.95Z"
          fill="white"
          stroke="#1D2B47"
          strokeWidth="0.6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M238.257 183.888H283.587V208.185H238.257V183.888Z"
          stroke="#1D2B47"
          strokeWidth="0.6"
        />
        <path
          d="M189.822 78.7403L179.61 64.581L135.207 98.3156C135.207 98.3156 98.744 67.4946 86.0292 61.2491C81.2929 58.9131 89.364 96.8576 89.364 96.8576L113.707 114.208C126.443 122.181 142.923 120.767 154.113 110.742L189.822 78.7403Z"
          fill="#2B5FCE"
          stroke="#1D2B47"
          strokeWidth="0.6"
        />
        <rect
          width="95.0746"
          height="114.083"
          rx="36.68"
          transform="matrix(-0.999392 -0.0348687 -0.0349303 0.99939 235.341 3.3252)"
          fill="#ACC7FA"
          stroke="#272D41"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <rect
          width="76.6725"
          height="93.4791"
          rx="5"
          transform="matrix(-0.999392 -0.0348687 -0.0349303 0.99939 225.783 13.3691)"
          fill="#F7F9FE"
          stroke="#272D41"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M142.635 100.977L143.58 74.624L152.402 66.921C154.427 65.1568 157.484 65.2994 159.335 67.2444L169.082 77.4782L186.055 64.9685C187.945 63.5725 190.551 63.6736 192.327 65.2117L224.051 92.7797L224.466 93.8887L224.109 103.896C224.042 105.746 222.487 107.191 220.636 107.126L145.855 104.45C144.007 104.378 142.566 102.824 142.635 100.977Z"
          fill="#ACC7FA"
        />
        <ellipse
          cx="3.96031"
          cy="3.95696"
          rx="3.96031"
          ry="3.95696"
          transform="matrix(-0.989253 0.146217 0.14647 0.989215 211.115 59.7109)"
          fill="#ACC7FA"
        />
        <rect
          width="76.6725"
          height="93.4791"
          rx="5"
          transform="matrix(-0.999392 -0.0348687 -0.0349303 0.99939 225.783 13.3691)"
          stroke="#272D41"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M223.348 2.90641C229.971 3.1375 235.153 8.69415 234.921 15.3175L231.775 105.346C231.543 111.969 225.986 117.151 219.363 116.92L148.331 114.442C141.708 114.211 136.526 108.654 136.758 102.031L139.905 12.0024C140.136 5.37901 145.693 0.197042 152.316 0.428132L223.348 2.90641ZM220.786 13.1944C223.546 13.2907 225.705 15.606 225.609 18.3657L222.693 101.794C222.596 104.554 220.281 106.713 217.521 106.617L150.889 104.292C148.129 104.195 145.97 101.88 146.067 99.1205L148.983 15.6923C149.079 12.9325 151.395 10.7734 154.154 10.8697L220.786 13.1944Z"
          fill="white"
        />
        <path
          d="M234.921 15.3175L235.221 15.328L234.921 15.3175ZM223.348 2.90641L223.358 2.6066L223.348 2.90641ZM231.775 105.346L231.475 105.335L231.775 105.346ZM219.363 116.92L219.352 117.22L219.363 116.92ZM148.331 114.442L148.342 114.142L148.331 114.442ZM136.758 102.031L137.058 102.041L136.758 102.031ZM139.905 12.0024L139.605 11.9919L139.905 12.0024ZM152.316 0.428132L152.306 0.72795L152.316 0.428132ZM225.609 18.3657L225.309 18.3552L225.609 18.3657ZM220.786 13.1944L220.797 12.8946L220.786 13.1944ZM222.693 101.794L222.992 101.804L222.693 101.794ZM217.521 106.617L217.531 106.317L217.521 106.617ZM150.889 104.292L150.879 104.592L150.889 104.292ZM146.067 99.1205L145.767 99.11L146.067 99.1205ZM148.983 15.6923L148.683 15.6818L148.983 15.6923ZM154.154 10.8697L154.144 11.1695L154.154 10.8697ZM234.622 15.307C234.847 8.84927 229.795 3.43154 223.337 3.20623L223.358 2.6066C230.147 2.84346 235.458 8.53904 235.221 15.328L234.622 15.307ZM231.475 105.335L234.622 15.307L235.221 15.328L232.075 105.356L231.475 105.335ZM219.373 116.62C225.831 116.846 231.249 111.793 231.475 105.335L232.075 105.356C231.837 112.145 226.141 117.457 219.352 117.22L219.373 116.62ZM148.342 114.142L219.373 116.62L219.352 117.22L148.321 114.742L148.342 114.142ZM137.058 102.041C136.832 108.499 141.884 113.917 148.342 114.142L148.321 114.742C141.532 114.505 136.221 108.809 136.458 102.02L137.058 102.041ZM140.204 12.0129L137.058 102.041L136.458 102.02L139.605 11.9919L140.204 12.0129ZM152.306 0.72795C145.848 0.502637 140.43 5.55507 140.204 12.0129L139.605 11.9919C139.842 5.20296 145.538 -0.108552 152.327 0.128314L152.306 0.72795ZM223.337 3.20623L152.306 0.72795L152.327 0.128314L223.358 2.6066L223.337 3.20623ZM225.309 18.3552C225.399 15.7611 223.37 13.5848 220.776 13.4943L220.797 12.8946C223.722 12.9967 226.011 15.4509 225.908 18.3762L225.309 18.3552ZM222.393 101.783L225.309 18.3552L225.908 18.3762L222.992 101.804L222.393 101.783ZM217.531 106.317C220.126 106.407 222.302 104.378 222.393 101.783L222.992 101.804C222.89 104.73 220.436 107.018 217.511 106.916L217.531 106.317ZM150.9 103.992L217.531 106.317L217.511 106.916L150.879 104.592L150.9 103.992ZM146.367 99.1309C146.276 101.725 148.305 103.901 150.9 103.992L150.879 104.592C147.953 104.49 145.665 102.035 145.767 99.11L146.367 99.1309ZM149.283 15.7027L146.367 99.1309L145.767 99.11L148.683 15.6818L149.283 15.7027ZM154.144 11.1695C151.55 11.079 149.373 13.1086 149.283 15.7027L148.683 15.6818C148.785 12.7565 151.239 10.4678 154.165 10.5698L154.144 11.1695ZM220.776 13.4943L154.144 11.1695L154.165 10.5698L220.797 12.8946L220.776 13.4943Z"
          fill="#272D41"
        />
        <path
          d="M104.325 219.157C109.175 172.912 102.342 133.713 92.131 109.037C69.4175 90.8622 56.9125 88.7949 56.9125 88.7949L71.2763 197.813L69.0751 221.801"
          fill="white"
        />
        <path
          d="M104.325 219.157C109.175 172.912 102.342 133.713 92.131 109.037C69.4175 90.8622 56.9125 88.7949 56.9125 88.7949L71.2763 197.813L69.0751 221.801"
          stroke="#1D2B47"
          strokeWidth="0.6"
        />
        <path
          d="M66.6343 182.381L71.2641 197.813L69.7135 214.578C69.7135 214.578 80.0711 200 81.3943 179.957C82.7174 159.915 79.0072 121.773 79.0072 121.773L66.6392 129.749L66.6343 182.381Z"
          fill="#1D2B47"
          stroke="#1D2B47"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M23 214.534L33.8004 196.696L34.6074 138.624C34.3687 129.593 36.1693 120.624 39.8756 112.383L41.0789 109.695L73.4799 108.155C73.4799 108.155 82.0571 176.959 63.6285 211.812C61.4274 215.966 59.1748 220.054 56.9003 224.03"
          fill="white"
        />
        <path
          d="M23 214.534L33.8004 196.696L34.6074 138.624C34.3687 129.593 36.1693 120.624 39.8756 112.383L41.0789 109.695L73.4799 108.155C73.4799 108.155 82.0571 176.959 63.6285 211.812C61.4274 215.966 59.1748 220.054 56.9003 224.03"
          stroke="#1D2B47"
          strokeWidth="0.6"
        />
        <path
          d="M43.4928 219.157C65.749 188.766 58.9205 145.606 55.6139 125.783L57.3723 125.346C60.5223 124.558 62.7941 121.816 62.9804 118.577L63.11 116.314"
          fill="white"
        />
        <path
          d="M43.4928 219.157C65.749 188.766 58.9205 145.606 55.6139 125.783L57.3723 125.346C60.5223 124.558 62.7941 121.816 62.9804 118.577L63.11 116.314"
          stroke="#B99BF9"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M78.9779 109.707L79.9562 125.458C80.0416 126.823 79.7488 128.185 79.11 129.394L75.368 136.481L73.6927 109.699"
          fill="white"
        />
        <path
          d="M78.9779 109.707L79.9562 125.458C80.0416 126.823 79.7488 128.185 79.11 129.394L75.368 136.481L73.6927 109.699"
          stroke="#1D2B47"
          strokeWidth="0.6"
        />
        <path
          d="M88.8979 219.156C96.6166 166.964 84.2681 109.706 84.2681 109.706L88.8979 219.156Z"
          fill="white"
        />
        <path
          d="M88.8979 219.156C96.6166 166.964 84.2681 109.706 84.2681 109.706"
          stroke="#B99BF9"
          strokeWidth="0.6"
        />
        <path
          d="M41 109.871H92L87.5386 62.0238C86.5767 51.737 77.9505 43.8728 67.6269 43.8711C57.657 43.8768 49.2135 51.2295 47.8299 61.1108L41 109.871Z"
          fill="white"
        />
        <path
          d="M41 109.871H92L87.5386 62.0238C86.5767 51.737 77.9505 43.8728 67.6269 43.8711C57.657 43.8768 49.2135 51.2295 47.8299 61.1108L41 109.871Z"
          fill="#2B5FCE"
        />
        <path
          d="M67.796 43.6436C57.7996 43.6492 49.3337 51.0092 47.9464 60.9001L41.0984 109.708H92.2338L87.7605 61.814"
          stroke="#1D2B47"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M73.6878 43.4229L79.9855 45.6489C80.7266 45.9108 81.2869 46.5266 81.4774 47.2886L81.9201 49.0528C82.0299 49.4912 81.8833 49.954 81.5411 50.2495C81.1988 50.5449 80.7192 50.6227 80.301 50.4506L75.0011 48.2685L73.6878 43.4229Z"
          fill="white"
          stroke="#1D2B47"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M69.7208 42.3213L76.5542 51.7901L77.8773 46.7246"
          fill="white"
        />
        <path
          d="M69.7208 42.3213L76.5542 51.7901L77.8773 46.7246"
          stroke="#1D2B47"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M80.3011 12.1504L82.1525 15.6789C83.0481 17.3733 83.0642 19.3967 82.1956 21.105C81.3271 22.8134 79.6821 23.9938 77.7844 24.2705L77.6744 24.2852L75.9623 23.21L74.0645 16.9838L80.3011 12.1504Z"
          fill="#1D2B47"
          stroke="#1D2B47"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M62 27.0197L62.7616 46.9137L76 49.8711L72.9412 25.8711"
          fill="#EEC493"
        />
        <path
          d="M77 57.8711L73 25.8711"
          stroke="#1D2B47"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M62 26.8711L63 46.8711"
          stroke="#1D2B47"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M74.1074 33.3565C74.1074 33.3565 70.7161 34.0633 68 32.8711C69.1765 36.3723 75 39.8711 75 39.8711L74.1074 33.3565Z"
          fill="#1D2B47"
        />
        <circle cx="70.5" cy="25.3711" r="8.5" fill="#EEC493" />
        <path
          d="M68.1947 33.9195C71.5918 34.8859 75.2367 33.706 77.4211 30.9328C79.6056 28.1596 79.8966 24.3426 78.158 21.2708C76.4193 18.1989 72.9954 16.4809 69.4909 16.922"
          stroke="#1D2B47"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M75.9159 10.0953C75.9159 10.0953 66.599 9.47441 63.8537 10.0953C61.1085 10.7161 56.093 13.5389 54.6522 16.0384C53.2114 18.5378 53.0252 21.5671 54.1489 24.224C55.6628 27.8039 58.133 31.391 62.1611 33.6073C62.1611 33.6073 66.7542 33.0282 66.2284 27.1026C63.247 26.3695 64.0272 22.0517 66.0841 22.4598C68.1409 22.8678 68.6325 26.802 68.6325 26.802C68.6325 26.802 70.8459 24.9669 69.5815 20.2434L76.8062 19.332L76.9627 19.31C82.9303 18.4743 81.9202 9.57968 75.9159 10.0953Z"
          fill="#1D2B47"
          stroke="#1D2B47"
          strokeWidth="0.6"
        />
        <path
          d="M76.831 10.8407H63.9785V9.84332C69.3174 8.15985 73.712 6.74554 78.2036 9.84332C79.1695 10.5094 79.4515 10.5913 80.4497 11.8381L76.831 10.8407Z"
          fill="#1D2B47"
        />
        <path
          d="M76.471 51.5693L75.4927 49.0305C75.0407 47.8463 74.0966 46.9165 72.9051 46.4818L62.9412 42.8531C61.8795 42.5435 60.7464 43.0237 60.2313 44.0016L60.0968 44.2606C59.4697 45.465 59.752 46.942 60.7792 47.8307L64.6923 51.1857C65.8154 52.1526 67.4854 52.1252 68.5762 51.1222L70.3151 49.5241C71.2392 48.6757 72.6456 48.6311 73.6217 49.419L76.3683 51.6402C76.39 51.6615 76.4238 51.6643 76.4489 51.647C76.4739 51.6298 76.4832 51.5972 76.471 51.5693Z"
          fill="white"
          stroke="#1D2B47"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M36.4197 122.274H42.83V141.193C42.8302 143.667 41.5788 145.973 39.5038 147.323L34.4338 150.625L33.3063 137.818C32.9008 133.246 33.6457 128.645 35.4732 124.435L36.4197 122.274Z"
          fill="#C7DAF8"
          stroke="#1D2B47"
          strokeWidth="0.6"
        />
        <path
          d="M119.633 104.474L144.269 60.1647L129.167 49.5352L96.9492 94.6191L73.8517 67.4466L57.502 84.1068L79.5943 112.03C90.83 123.304 109.677 121.012 117.887 107.387L119.633 104.474Z"
          fill="#EEC493"
          stroke="#1D2B47"
          strokeWidth="0.6"
        />
        <path
          d="M130.368 58.6147L139.045 43.3742C139.948 41.7885 139.425 39.7733 137.866 38.8242L136.939 38.2598L124.938 55.311L130.368 58.6147Z"
          fill="#EEC493"
        />
        <path
          d="M143.452 58.8978L159.626 52.569C160.57 52.1984 161.041 51.1399 160.685 50.1914C160.352 49.3036 159.402 48.81 158.484 49.0478L142.107 53.285L143.452 58.8978Z"
          fill="#EEC493"
          stroke="#1A1C35"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M144.587 55.0156L148.955 52.7627L151.056 51.6777L160.022 47.052C160.922 46.585 161.281 45.4836 160.829 44.5767C160.406 43.7291 159.411 43.337 158.523 43.6677L142.677 49.5714L144.587 55.0156Z"
          fill="#EEC493"
        />
        <path
          d="M149.795 52.3883L151.22 51.6685L160.017 47.2304C160.9 46.7823 161.252 45.7256 160.809 44.8554C160.394 44.0422 159.417 43.6659 158.546 43.9833L143 49.6476L144.876 54.8711"
          stroke="#1A1C35"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M149 56.6101L141.894 40.8711L133.035 45.1346L124 56.3465L139.946 64.8711C143.765 63.5612 146.933 60.7594 148.771 57.0675L149 56.6101Z"
          fill="#EEC493"
        />
        <path
          d="M140 64.8711C143.8 63.5777 146.946 60.8657 148.773 57.3081L149 56.8711"
          stroke="#1A1C35"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M124 56.8711L136.529 37.8711L137.44 38.458C138.668 39.2482 139.207 40.4373 138.928 41.8525"
          stroke="#1A1C35"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M143.894 50.8711L159.951 42.6078C160.875 42.1225 161.258 40.9657 160.817 39.9962C160.393 39.0827 159.371 38.6468 158.448 38.9855L142 45.021L143.894 50.8711Z"
          fill="#EEC493"
        />
        <path
          d="M148.144 47.8711L159.938 42.3301C160.876 41.8821 161.264 40.8064 160.811 39.9089C160.384 39.0663 159.354 38.6642 158.423 38.9766L143 44.1394"
          stroke="#1A1C35"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M142.412 46.8711L155.032 40.214C155.919 39.7459 156.255 38.6986 155.793 37.8433C155.355 37.0322 154.341 36.6637 153.441 36.9888L141 41.4609L142.412 46.8711Z"
          fill="#EEC493"
        />
        <path
          d="M146.087 45.8711L155.065 40.4877C155.921 39.9812 156.246 38.8482 155.8 37.9229C155.377 37.0454 154.397 36.6468 153.527 36.9985L137 43.4469"
          stroke="#1A1C35"
          strokeWidth="0.6"
          strokeLinecap="round"
        />
        <path
          d="M49 81.3054L79.772 112.233C90.9675 123.484 110.771 131.852 123.029 116.486L137 96.7352L125.86 93.5434L109.63 77.2529L97.0649 94.8601L66.7584 58.9192L57.4418 47.8711"
          fill="#2B5FCE"
        />
        <path
          d="M49 80.7733L79.772 112.08C90.9675 123.468 110.771 131.938 123.029 116.384L137 96.3918L125.86 93.161L109.63 76.6712L97.0649 94.4938L69.812 61.8721"
          stroke="#1D2B47"
          strokeWidth="0.6"
        />
        <path
          d="M137.339 88.364L131.747 82.8721L126 93.0108L129.282 96.2346C131.5 98.4132 135.102 98.4186 137.327 96.2467C138.396 95.203 138.998 93.7861 139 92.3078C139.002 90.8295 138.405 89.4108 137.339 88.364Z"
          fill="#1D2B47"
          stroke="#1D2B47"
          strokeWidth="0.6"
        />
      </g>
      <defs>
        <clipPath id="clip0_17125_5485">
          <rect width="499" height="212" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
